"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.di = exports.getInstance = exports.Resolve = exports.tryResolve = exports.injectable = exports.Register = void 0;
var tslib_1 = require("tslib");
var container_1 = tslib_1.__importDefault(require("./container"));
var tempId = 0;
function getNextId() {
    return tempId++;
}
var container = new container_1.default();
function Register(name, scope) {
    if (scope === void 0) { scope = "Singleton"; }
    if (!name) {
        name = "di-autoname-" + getNextId();
    }
    return {
        value: function (value, overwrite) {
            if (overwrite === void 0) { overwrite = true; }
            if (!container.has(name) || overwrite) {
                container
                    .bind(name)
                    .toValue(value)
                    .setScope(scope);
            }
        },
        class: function (BindingClass, params, overwrite) {
            var _a;
            if (params === void 0) { params = []; }
            if (overwrite === void 0) { overwrite = true; }
            if (!container.has(name) || overwrite) {
                (_a = container
                    .bind(name)
                    .to(BindingClass)).params.apply(_a, tslib_1.__spread(params)).setScope(scope);
                BindingClass.$$di_NAME = name;
            }
        },
        factory: function (factory, params, overwrite) {
            var _a;
            if (params === void 0) { params = []; }
            if (overwrite === void 0) { overwrite = true; }
            if (!container.has(name) || overwrite) {
                (_a = container
                    .bind(name)
                    .toFactory(factory)).params.apply(_a, tslib_1.__spread(params)).setScope(scope);
            }
        },
    };
}
exports.Register = Register;
function injectable(name, scope) {
    if (scope === void 0) { scope = "Singleton"; }
    return function (BindingClass) {
        Register(name, scope).class(BindingClass, [], false);
    };
}
exports.injectable = injectable;
function tryResolve(key) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var bean = container.resolve.apply(container, tslib_1.__spread([key], args));
    if (bean) {
        return bean;
    }
    return null;
}
exports.tryResolve = tryResolve;
function Resolve(key) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var bean = tryResolve.apply(void 0, tslib_1.__spread([key], args));
    if (bean) {
        return bean;
    }
    else {
        throw new Error("Context has no bean with name " + key + ".\n      Available beans: " + tslib_1.__spread(container.getNames()).join(", "));
    }
}
exports.Resolve = Resolve;
function getInstance(Binding, args, scope) {
    var _a, _b;
    if (args === void 0) { args = []; }
    if (!Binding.$$di_NAME) {
        var name_1 = (_a = Binding.diOptions) === null || _a === void 0 ? void 0 : _a.name;
        if (!scope) {
            scope = ((_b = Binding.diOptions) === null || _b === void 0 ? void 0 : _b.scope) || "Singleton";
        }
        Register(name_1, scope).class(Binding);
    }
    return Resolve.apply(void 0, tslib_1.__spread([Binding.$$di_NAME], args));
}
exports.getInstance = getInstance;
/**
 * 注入一个对象
 * @deprecated
 * @param Binding
 */
function Inject(Binding) {
    return function (target, propertyKey, desc) {
        var options = {
            get: function () {
                if (typeof Binding == "string") {
                    return tryResolve(Binding);
                }
                else {
                    return getInstance(Binding);
                }
            },
            set: function () {
                throw new Error("Not allowed");
            },
            enumerable: true,
            configurable: true,
        };
        if (desc) {
            return options;
        }
        Object.defineProperty(target, propertyKey, options);
        return;
    };
}
function Request(Binding, args) {
    if (args === void 0) { args = []; }
    return getInstance(Binding, args, "Request");
}
function Singleton(Binding, args) {
    if (args === void 0) { args = []; }
    return getInstance(Binding, args, "Singleton");
}
function Transient(Binding, args) {
    if (args === void 0) { args = []; }
    return getInstance(Binding, args, "Transient");
}
function options(options) {
    if (!options.name) {
        options.name = "$$di_auto_" + getNextId();
    }
    if (!options.scope) {
        options.scope = "Singleton";
    }
    return options;
}
exports.di = {
    injectable: injectable,
    tryResolve: tryResolve,
    Resolve: Resolve,
    Inject: Inject,
    getInstance: getInstance,
    Register: Register,
    Request: Request,
    Singleton: Singleton,
    Transient: Transient,
    options: options,
};
exports.default = exports.di;
